import React, { useEffect, useRef, useState } from "react";
import "../../RdssForms/rdssforms.scss";

export const FdDiscomLogHistory = (FdLogHistoryBlock: any) => {

  let discomHistoryNo = 0;
  const [getFdHistoryBlock, setFdHistoryBlock] = useState<any[]>([]);

  useEffect(() => {
    (async () => {
      setFdHistoryBlock(FdLogHistoryBlock.FdLogHistoryBlock);
    })();
  }, [FdLogHistoryBlock.FdLogHistoryBlock]);

  return (
    <>
      {(FdLogHistoryBlock.FdLogHistoryBlock.length > 0) ?
        <div className="accordion-body">
          <div className="table-responsive RevenueDetailsTable actionHistory">
            <h4 className="accordion-header blankPara">Log History</h4>
            <table className="table">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Updated By</th>
                  <th>Timestamp</th>
                </tr>
              </thead>
              <tbody>
                {(getFdHistoryBlock.length > 0) ?
                  getFdHistoryBlock.map((item: any, key: number) => (
                    <>
                      <tr key={key}>
                        <td>{(discomHistoryNo++) + 1}</td>
                        <td>{item.updated_by}</td>
                        <td>{item.updated_date_time}</td>
                      </tr>
                    </>
                  ))
                  : null
                }
              </tbody>
            </table>
          </div>
        </div>
        : null
      }
    </>
  );
}
export default FdDiscomLogHistory;

